import { render, staticRenderFns } from "./productRoadMap.vue?vue&type=template&id=31eec7ac&scoped=true&"
import script from "./productRoadMap.vue?vue&type=script&lang=js&"
export * from "./productRoadMap.vue?vue&type=script&lang=js&"
import style0 from "./productRoadMap.vue?vue&type=style&index=0&id=31eec7ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eec7ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31eec7ac')) {
      api.createRecord('31eec7ac', component.options)
    } else {
      api.reload('31eec7ac', component.options)
    }
    module.hot.accept("./productRoadMap.vue?vue&type=template&id=31eec7ac&scoped=true&", function () {
      api.rerender('31eec7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/productRoadMap.vue"
export default component.exports